import { render, staticRenderFns } from "./BestsellersSettings.vue?vue&type=template&id=10b91ec4"
import script from "./BestsellersSettings.vue?vue&type=script&lang=js"
export * from "./BestsellersSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports